import React, { useCallback } from "react";
import {useDispatch, useSelector} from "react-redux";
import { useRestaurant } from '../contexts/restaurant.context';
import { hideCategoryDisabledAlert } from '../store/actions/menu.actions';
import { Modal } from './Modal';

function MenuCategoryAlert() {
    const dispatch = useDispatch();

    const category = useSelector(state => state.menu.disabledCategory);
    const restaurant = useRestaurant();

    const currentHours = category?.business_hours.find(h => h.dayNumber === restaurant.todayNumber);

    const handleCloseAlert = useCallback((e) => {
        dispatch(hideCategoryDisabledAlert());
    }, [dispatch]);
    
    return (
        <Modal title="Attention!" onClose={handleCloseAlert} isOpen={!!category}>
            {currentHours && (
                <p>
                    This item is available only during {currentHours?.begin} - {currentHours?.end}
                </p>
            )}
            {!currentHours && (
                <p>
                    The item is not available today.
                </p>
            )}
        </Modal>
    )
}

export default MenuCategoryAlert;